
import React from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <div className="flex items-center rounded-full bg-black/20 backdrop-blur-sm">
      <button 
        onClick={() => setLanguage('fr')}
        className={cn(
          "px-4 py-1.5 rounded-full transition-colors text-sm font-medium",
          language === 'fr' 
            ? "bg-singu-yellow text-singu-dark" 
            : "text-gray-300 hover:text-white"
        )}
        aria-label="Switch to French"
      >
        FR
      </button>
      <span className="text-gray-400 mx-1">|</span>
      <button 
        onClick={() => setLanguage('en')}
        className={cn(
          "px-4 py-1.5 rounded-full transition-colors text-sm font-medium",
          language === 'en' 
            ? "bg-singu-yellow text-singu-dark" 
            : "text-gray-300 hover:text-white"
        )}
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
